var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Event, Prop, State } from '@sick-davinci/ce-decorators';
import { style } from './Slider.style';
import { AbstractSlider } from './AbstractSlider';
/**
 * A `davinci-slider` can be used to choose a value between a specific range.
 *
 * @example
 * ```html
 * <div style="padding-top:40px"> <!-- takes care that there is enough space at the top of the viewport to also display the value indicator -->
 *   <davinci-slider icon-left="av/volume_mute" value="50" icon-right="av/volume_up"></davinci-slider>
 * </div>
 * ```
 */

export let Slider = (_dec = Component({
  tag: 'davinci-slider',
  style,
  dependencies: [AbstractSlider]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop({
  reflectAsAttribute: false
}), _dec4 = Reflect.metadata("design:type", Number), _dec5 = Event(), _dec6 = Reflect.metadata("design:type", Object), _dec7 = Event(), _dec8 = Reflect.metadata("design:type", Object), _dec9 = State(), _dec10 = Reflect.metadata("design:type", Number), _dec(_class = _dec2(_class = (_class2 = class Slider extends AbstractSlider {
  constructor() {
    super();

    _initializerDefineProperty(this, "change", _descriptor, this);

    _initializerDefineProperty(this, "input", _descriptor2, this);

    _initializerDefineProperty(this, "relativeValue", _descriptor3, this);

    _defineProperty(this, "_valueHasChanged", false);

    _defineProperty(this, "keyDownEvent", event => {
      if (this.KEY_CODE_ARROW_UP.includes(event.key) || this.KEY_CODE_ARROW_RIGHT.includes(event.key)) {
        this.updateValueAndEmit(this.increment(), true, false);
        event.preventDefault();
      } else if (this.KEY_CODE_ARROW_DOWN.includes(event.key) || this.KEY_CODE_ARROW_LEFT.includes(event.key)) {
        this.updateValueAndEmit(this.decrement(), true, false);
        event.preventDefault();
      }
    });

    _defineProperty(this, "_keyUpEvent", event => {
      if (this.KEY_CODE_ARROW_UP.includes(event.key) || this.KEY_CODE_ARROW_RIGHT.includes(event.key) || this.KEY_CODE_ARROW_DOWN.includes(event.key) || this.KEY_CODE_ARROW_LEFT.includes(event.key)) {
        this.updateValueAndEmit(this.value, false, true);
        event.preventDefault();
      }
    });

    this._value = [0];
  }

  get value() {
    return this._value[0];
  }
  /**
   * Current value of the slider.
   */


  set value(value) {
    this._value[0] = value;
    this.updateState();
  }
  /**
   * Emitted [Number] if the value changes.
   */


  render() {
    return this.renderSlider([this.value]);
  }

  componentConnected() {
    super.componentConnected();
    this.addEventListener('keyup', this._keyUpEvent);
  }

  componentDisconnected() {
    super.componentDisconnected();
    this.removeEventListener('keyup', this._keyUpEvent);
  }
  /**
   * @override
   * @param event
   */


  /**
   * @override
   */
  updateValueAndEmit(value, emitInput, emitChange) {
    // The input event is processed first, so we need to store whether the
    // value has changed in order to be able to retrieve that information
    // when the change event is processed later on.
    this._valueHasChanged = this.value !== value || this._valueHasChanged;
    this.value = value;

    if (emitInput) {
      this.input.emit(this.value);
    }

    if (emitChange && this._valueHasChanged) {
      this._valueHasChanged = false;
      this.change.emit(this.value);
    }
  } // ToDo @6.0.0 -> remove method and use onNumericFieldChange() directly

  /**
   * @override
   */


  synchronizeValueFieldValue(index, _initialValue, newValue) {
    this.onNumericFieldChange(newValue[index]);
  }

  onNumericFieldChange(newValue, index = 0) {
    if (this.value === newValue) {
      this.overwriteInputFieldValue(index, newValue);
    } else {
      this.value = newValue;
      this.change.emit(this.value);
    }
  }
  /**
   * @override
   */


  updateSyncedState() {
    this._value[0] = this.roundWithTicks(this._value[0]);
    this._value[0] = this.validateValue(this._value[0]);
    this.relativeValue = this.map(this._value[0], this.min, this.max, 0, 100);
    this.knobPositions = [this.relativeValue, null];
    this._value = [this.value, null];
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec3, _dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec7, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "relativeValue", [_dec9, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
})), _class2)) || _class) || _class);
